import { testIds } from "@/lib/api";

const services = [
  {
    tag: "01",
    title: "Physical Training",
    body: "Progressive strength & conditioning programs built around your life — not the other way around. Small-group and 1:1 formats.",
    image:
      "https://images.unsplash.com/photo-1517130038641-a774d04afb3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwYm9vdGNhbXAlMjBncm91cCUyMHdvcmtvdXR8ZW58MHx8fHwxNzgyNTUyNDQwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "02",
    title: "Mental Wellness",
    body: "Breathwork, guided journaling, sleep protocols, and stress-load coaching. Because a nervous system in overdrive can't recover.",
    image:
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtZWRpdGF0aW9uJTIwbmF0dXJlJTIwY2FsbXxlbnwwfHx8fDE3ODI5NjY5MTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "03",
    title: "Nutrition Coaching",
    body: "No cutting out food groups. No spreadsheets you'll abandon. Just habits, meal templates, and grocery strategies that fit real life.",
    image:
      "https://images.unsplash.com/photo-1490645935967-10de6ba17061?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwbnV0cml0aW9uJTIwZm9vZCUyMGJvd2x8ZW58MHx8fHwxNzgyOTY2OTE5fDA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid={testIds.services.section}
      className="py-24 md:py-32 px-6 md:px-12 bg-white/60 border-y border-[#E5E2D9]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-20">
          <div>
            <div className="overline mb-4">The Approach</div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter text-[#2D372B] leading-[1.02]">
              Three pillars.
              <br />
              <span className="italic">One practice.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#5C665A] leading-relaxed">
            Every program blends training, mindfulness, and nutrition in
            proportions that match where you are — not where a template says
            you should be.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {services.map((s) => (
            <article
              key={s.tag}
              className="group bg-white border border-[#E5E2D9] rounded-3xl overflow-hidden hover:shadow-lg transition-all duration-500 hover:-translate-y-1"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-serif-display italic text-[#AD6A48] text-xl">{s.tag}</span>
                  <span className="h-px flex-1 bg-[#E5E2D9]" />
                </div>
                <h3 className="font-serif-display text-3xl font-medium tracking-tight text-[#2D372B] mb-3">
                  {s.title}
                </h3>
                <p className="text-[#5C665A] leading-relaxed">{s.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
